module.exports = __webpack_public_path__ + "static/assets/851851e78b3155f3e92a4c6bbd377160.png";